"use strict";

exports.__esModule = true;
exports.DataSourceField = DataSourceField;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DataSourceField(props) {
  var setProp = props.setProp,
    value = props.value;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTableFields.dataSource.label", "Data Source"),
    helperText: translate("DataTableFields.dataSource.helperText", "Select the data to display in the table.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    value: value,
    onChange: function onChange(e) {
      return setProp(e.target.value || undefined);
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "Alerts"
  }, translate("DataTableFields.dataSource.alerts.label", "Alerts")), false && /*#__PURE__*/_react["default"].createElement("option", {
    value: "Comments"
  }, translate("DataTableFields.dataSource.comments.label", "Comments")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Tickets"
  }, translate("DataTableFields.dataSource.tickets.label", "Tickets")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "AuditLogs"
  }, translate("DataTableFields.dataSource.auditLogs.label", "AuditLogs")))));
}